import { render, staticRenderFns } from "./RuleManage.vue?vue&type=template&id=7f4719e6&scoped=true&"
import script from "./RuleManage.vue?vue&type=script&lang=js&"
export * from "./RuleManage.vue?vue&type=script&lang=js&"
import style0 from "./RuleManage.vue?vue&type=style&index=0&id=7f4719e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4719e6",
  null
  
)

export default component.exports